import { BarbellIcon } from "@phosphor-icons/react/dist/csr/Barbell";
import { BookOpenIcon } from "@phosphor-icons/react/dist/csr/BookOpen";
import { BrainIcon } from "@phosphor-icons/react/dist/csr/Brain";
import { BroomIcon } from "@phosphor-icons/react/dist/csr/Broom";
import { CalendarDotsIcon } from "@phosphor-icons/react/dist/csr/CalendarDots";
import { CameraIcon } from "@phosphor-icons/react/dist/csr/Camera";
import { CardsIcon } from "@phosphor-icons/react/dist/csr/Cards";
import { CarrotIcon } from "@phosphor-icons/react/dist/csr/Carrot";
import { ChalkboardTeacherIcon } from "@phosphor-icons/react/dist/csr/ChalkboardTeacher";
import { ChartBarIcon } from "@phosphor-icons/react/dist/csr/ChartBar";
import { ChatCircleIcon } from "@phosphor-icons/react/dist/csr/ChatCircle";
import { CheckCircleIcon } from "@phosphor-icons/react/dist/csr/CheckCircle";
import { ChefHatIcon } from "@phosphor-icons/react/dist/csr/ChefHat";
import { ClipboardTextIcon } from "@phosphor-icons/react/dist/csr/ClipboardText";
import { CoffeeIcon } from "@phosphor-icons/react/dist/csr/Coffee";
import { ConfettiIcon } from "@phosphor-icons/react/dist/csr/Confetti";
import { CookingPotIcon } from "@phosphor-icons/react/dist/csr/CookingPot";
import { CreditCardIcon } from "@phosphor-icons/react/dist/csr/CreditCard";
import { DeviceMobileIcon } from "@phosphor-icons/react/dist/csr/DeviceMobile";
import { DeviceMobileSlashIcon } from "@phosphor-icons/react/dist/csr/DeviceMobileSlash";
import { DropIcon } from "@phosphor-icons/react/dist/csr/Drop";
import { EarIcon } from "@phosphor-icons/react/dist/csr/Ear";
import { EnvelopeSimpleIcon } from "@phosphor-icons/react/dist/csr/EnvelopeSimple";
import { FireIcon } from "@phosphor-icons/react/dist/csr/Fire";
import { FlowerLotusIcon } from "@phosphor-icons/react/dist/csr/FlowerLotus";
import { FootprintsIcon } from "@phosphor-icons/react/dist/csr/Footprints";
import { ForkKnifeIcon } from "@phosphor-icons/react/dist/csr/ForkKnife";
import { GlobeHemisphereWestIcon } from "@phosphor-icons/react/dist/csr/GlobeHemisphereWest";
import { GraduationCapIcon } from "@phosphor-icons/react/dist/csr/GraduationCap";
import { HandHeartIcon } from "@phosphor-icons/react/dist/csr/HandHeart";
import { HandWavingIcon } from "@phosphor-icons/react/dist/csr/HandWaving";
import { HandsPrayingIcon } from "@phosphor-icons/react/dist/csr/HandsPraying";
import { HandshakeIcon } from "@phosphor-icons/react/dist/csr/Handshake";
import { HeadphonesIcon } from "@phosphor-icons/react/dist/csr/Headphones";
import { HeartIcon } from "@phosphor-icons/react/dist/csr/Heart";
import { LeafIcon } from "@phosphor-icons/react/dist/csr/Leaf";
import { LightbulbIcon } from "@phosphor-icons/react/dist/csr/Lightbulb";
import { LightningIcon } from "@phosphor-icons/react/dist/csr/Lightning";
import { MagnifyingGlassIcon } from "@phosphor-icons/react/dist/csr/MagnifyingGlass";
import { MaskHappyIcon } from "@phosphor-icons/react/dist/csr/MaskHappy";
import { VirusIcon } from "@phosphor-icons/react/dist/csr/Virus";
import { MoneyIcon } from "@phosphor-icons/react/dist/csr/Money";
import { MoonStarsIcon } from "@phosphor-icons/react/dist/csr/MoonStars";
import { MusicNoteIcon } from "@phosphor-icons/react/dist/csr/MusicNote";
import { MusicNotesIcon } from "@phosphor-icons/react/dist/csr/MusicNotes";
import { NewspaperIcon } from "@phosphor-icons/react/dist/csr/Newspaper";
import { NotePencilIcon } from "@phosphor-icons/react/dist/csr/NotePencil";
import { NotebookIcon } from "@phosphor-icons/react/dist/csr/Notebook";
import { PackageIcon } from "@phosphor-icons/react/dist/csr/Package";
import { PaintBrushIcon } from "@phosphor-icons/react/dist/csr/PaintBrush";
import { PaletteIcon } from "@phosphor-icons/react/dist/csr/Palette";
import { PenIcon } from "@phosphor-icons/react/dist/csr/Pen";
import { PenNibIcon } from "@phosphor-icons/react/dist/csr/PenNib";
import { PencilIcon } from "@phosphor-icons/react/dist/csr/Pencil";
import { PersonSimpleWalkIcon } from "@phosphor-icons/react/dist/csr/PersonSimpleWalk";
import { PhoneIcon } from "@phosphor-icons/react/dist/csr/Phone";
import { PillIcon } from "@phosphor-icons/react/dist/csr/Pill";
import { ProhibitIcon } from "@phosphor-icons/react/dist/csr/Prohibit";
import { RocketIcon } from "@phosphor-icons/react/dist/csr/Rocket";
import { ShoppingCartIcon } from "@phosphor-icons/react/dist/csr/ShoppingCart";
import { SmileyIcon } from "@phosphor-icons/react/dist/csr/Smiley";
import { SneakerMoveIcon } from "@phosphor-icons/react/dist/csr/SneakerMove";
import { SparkleIcon } from "@phosphor-icons/react/dist/csr/Sparkle";
import { StarIcon } from "@phosphor-icons/react/dist/csr/Star";
import { StrategyIcon } from "@phosphor-icons/react/dist/csr/Strategy";
import { SunIcon } from "@phosphor-icons/react/dist/csr/Sun";
import { SunHorizonIcon } from "@phosphor-icons/react/dist/csr/SunHorizon";
import { TargetIcon } from "@phosphor-icons/react/dist/csr/Target";
import { ToothIcon } from "@phosphor-icons/react/dist/csr/Tooth";
import { TreeIcon } from "@phosphor-icons/react/dist/csr/Tree";
import { TrendUpIcon } from "@phosphor-icons/react/dist/csr/TrendUp";
import { UsersThreeIcon } from "@phosphor-icons/react/dist/csr/UsersThree";
import { WindIcon } from "@phosphor-icons/react/dist/csr/Wind";
import { YarnIcon } from "@phosphor-icons/react/dist/csr/Yarn";

import { ICONS } from "./icon-catalog";

import type { Icon } from "@phosphor-icons/react";

export type InkColor =
  | "blue"
  | "gold"
  | "coral"
  | "periwinkle"
  | "rose"
  | "apricot"
  | "lavender"
  | "sage";
const symbols: Record<string, { glyph: Icon; color: InkColor }> = {
  Heart: { glyph: HeartIcon, color: "rose" },
  "Flexed biceps": { glyph: BarbellIcon, color: "periwinkle" },
  Runner: { glyph: SneakerMoveIcon, color: "coral" },
  Meditation: { glyph: FlowerLotusIcon, color: "rose" },
  "Water drop": { glyph: DropIcon, color: "blue" },
  "Weight lifting": { glyph: BarbellIcon, color: "periwinkle" },
  Sleeping: { glyph: MoonStarsIcon, color: "lavender" },
  Moon: { glyph: MoonStarsIcon, color: "lavender" },
  Coffee: { glyph: CoffeeIcon, color: "apricot" },
  Cooking: { glyph: CookingPotIcon, color: "coral" },
  Pill: { glyph: PillIcon, color: "blue" },
  Tooth: { glyph: ToothIcon, color: "blue" },
  Sun: { glyph: SunIcon, color: "gold" },
  Microbe: { glyph: VirusIcon, color: "sage" },
  Footprints: { glyph: FootprintsIcon, color: "coral" },
  Books: { glyph: BookOpenIcon, color: "gold" },
  "Playing card": { glyph: CardsIcon, color: "periwinkle" },
  Globe: { glyph: GlobeHemisphereWestIcon, color: "blue" },
  Headphones: { glyph: HeadphonesIcon, color: "periwinkle" },
  "Graduation cap": { glyph: GraduationCapIcon, color: "gold" },
  "Writing hand": { glyph: PenNibIcon, color: "apricot" },
  "Open book": { glyph: BookOpenIcon, color: "gold" },
  "Chess pawn": { glyph: StrategyIcon, color: "periwinkle" },
  "Music note": { glyph: MusicNoteIcon, color: "rose" },
  Newspaper: { glyph: NewspaperIcon, color: "blue" },
  Clipboard: { glyph: ClipboardTextIcon, color: "apricot" },
  Brain: { glyph: BrainIcon, color: "rose" },
  Email: { glyph: EnvelopeSimpleIcon, color: "blue" },
  Tomato: { glyph: CarrotIcon, color: "coral" },
  Phone: { glyph: DeviceMobileIcon, color: "blue" },
  Broom: { glyph: BroomIcon, color: "sage" },
  Calendar: { glyph: CalendarDotsIcon, color: "blue" },
  Bullseye: { glyph: TargetIcon, color: "coral" },
  Sparkles: { glyph: SparkleIcon, color: "gold" },
  "Art palette": { glyph: PaletteIcon, color: "rose" },
  "Smiling face": { glyph: SmileyIcon, color: "gold" },
  "Glowing star": { glyph: StarIcon, color: "gold" },
  "Face massage": { glyph: HandHeartIcon, color: "rose" },
  Bubbles: { glyph: DropIcon, color: "blue" },
  Telephone: { glyph: PhoneIcon, color: "sage" },
  "Speech bubble": { glyph: ChatCircleIcon, color: "sage" },
  "Green heart": { glyph: HeartIcon, color: "sage" },
  "Party popper": { glyph: ConfettiIcon, color: "rose" },
  Ear: { glyph: EarIcon, color: "apricot" },
  "Folded hands": { glyph: HandsPrayingIcon, color: "rose" },
  "Waving hand": { glyph: HandWavingIcon, color: "apricot" },
  Pencil: { glyph: PencilIcon, color: "apricot" },
  Camera: { glyph: CameraIcon, color: "periwinkle" },
  Pen: { glyph: PenIcon, color: "apricot" },
  "Light bulb": { glyph: LightbulbIcon, color: "gold" },
  "Music notes": { glyph: MusicNotesIcon, color: "rose" },
  Yarn: { glyph: YarnIcon, color: "rose" },
  Paintbrush: { glyph: PaintBrushIcon, color: "rose" },
  "Credit card": { glyph: CreditCardIcon, color: "sage" },
  "Money bag": { glyph: MoneyIcon, color: "sage" },
  "Shopping cart": { glyph: ShoppingCartIcon, color: "coral" },
  "Chart up": { glyph: TrendUpIcon, color: "sage" },
  "Bar chart": { glyph: ChartBarIcon, color: "sage" },
  Rocket: { glyph: RocketIcon, color: "coral" },
  Memo: { glyph: NotePencilIcon, color: "apricot" },
  Fire: { glyph: FireIcon, color: "coral" },
  Herb: { glyph: LeafIcon, color: "sage" },
  Tree: { glyph: TreeIcon, color: "sage" },
  Sunrise: { glyph: SunHorizonIcon, color: "gold" },
  "No phone": { glyph: DeviceMobileSlashIcon, color: "blue" },
  Prohibited: { glyph: ProhibitIcon, color: "coral" },
  "Mechanical leg": { glyph: PersonSimpleWalkIcon, color: "coral" },
  Notebook: { glyph: NotebookIcon, color: "apricot" },
  Wind: { glyph: WindIcon, color: "blue" },
  "Magnifying glass": { glyph: MagnifyingGlassIcon, color: "blue" },
  Package: { glyph: PackageIcon, color: "apricot" },
  Family: { glyph: UsersThreeIcon, color: "sage" },
  Teacher: { glyph: ChalkboardTeacherIcon, color: "gold" },
  Handshake: { glyph: HandshakeIcon, color: "sage" },
  Cook: { glyph: ChefHatIcon, color: "coral" },
  "Performing arts": { glyph: MaskHappyIcon, color: "rose" },
  "Fork and knife": { glyph: ForkKnifeIcon, color: "coral" },
  "Money with wings": { glyph: MoneyIcon, color: "sage" },
};
const normalize = (value: string) => value.replace(/\uFE0F/g, "");
const stored = new Map(ICONS.map(({ emoji, label }) => [normalize(emoji), label]));
const aliases: Record<string, string> = {
  water: "Water drop",
  drop: "Water drop",
  dumbbell: "Weight lifting",
  barbell: "Weight lifting",
  heart: "Heart",
  book: "Books",
  "book-open": "Books",
  meditation: "Meditation",
  moon: "Moon",
  notebook: "Notebook",
  leaf: "Herb",
  "⚡": "Energy",
};
const artwork: Record<string, string> = {
  "Water drop": "water",
  Books: "book",
  "Open book": "book",
  "Weight lifting": "workout",
  "Flexed biceps": "workout",
  Meditation: "meditate",
  Sleeping: "sleep",
  Moon: "sleep",
  Notebook: "journal",
  Memo: "journal",
};
export function resolveHabitIcon(value: string) {
  const normalized = normalize(value);
  const label = stored.get(normalized) ?? aliases[normalized] ?? value;
  const symbol =
    symbols[label] ??
    (label === "Energy"
      ? { glyph: LightningIcon, color: "gold" as const }
      : { glyph: CheckCircleIcon, color: "sage" as const });
  return { ...symbol, artwork: artwork[label], label };
}
export function habitInkColor(value: string) {
  return `var(--icon-${resolveHabitIcon(value).color})`;
}
// Used only for newly created defaults; never overwrite a user's persisted colors.
export const INK_COLORS = {
  blue: "#86b5c4",
  gold: "#cfb979",
  coral: "#d4a18c",
  periwinkle: "#a4accc",
  rose: "#c99cad",
  apricot: "#d0aa81",
  lavender: "#b6accd",
  sage: "#98b493",
};
export function defaultHabitColor(value: string) {
  return INK_COLORS[resolveHabitIcon(value).color];
}
